import React from "react";

import Browse, { FilterData } from "../../components/browse/Browse";
import BrowseList from "../../components/browse/BrowseList";
import { useFilterQueryParam } from "../../components/browse/useSearch";

const defaultSearchFilter: FilterData = {
  grade: [],
  type: ["COURSE"],
  query: "",
  bankId: [],
};
const BrowseRoute = () => {
  const [searchFilter, setSearchFilter] =
    useFilterQueryParam(defaultSearchFilter);

  return (
    <Browse
      resultList={BrowseList}
      withFilters={{
        bank: true,
        subject: true,
        language: true,
        grade: true,
        objectives: true,
        type: true,
        query: true,
      }}
      searchFilter={searchFilter}
      setSearchFilter={setSearchFilter}
      onFilterClear={() => {
        setSearchFilter(defaultSearchFilter);
      }}
    />
  );
};

export default BrowseRoute;
